import GoogleMapReact from 'google-map-react';
import { array, arrayOf, bool, func, node, number, object, shape, string } from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { googleApiKey } from '../../global/utils/commonUtils';
import useMedia from '../../../hooks/useMedia';
import useLLP from '../../location/hooks/useLLP';
import Marker from './Marker';
import LocationLegend from '../../global/modules/locationLegend';
import CurrentLocationMarker from '../../../resources/images/current-location-marker.svg';
import './trainerMap.scss';
import { googleMapStyles } from '../constants';
import { MAP_LAT_LONG_BOUNDS } from '../../location/constants';
import { ENV_CONFIG } from '../../../constants/envConfig';
import { MEDIA_TYPE } from '../../global/constants';
import { isValidString } from '../../global/utils/logger';

const TrainerMap = props => {
    const {
        selectedLatLong,
        storesList,
        selectedStoreValue,
        onClickMarker,
        defaultCenter,
        isCurrentLocationAllowed,
        currentLocation,
        setFocusedLocation,
        zoomOutMax,
        userLatLong,
        legendItems
    } = props;
    const { setDefZoom, setMinZoom } = useLLP();
    const mediaType = useMedia();
    const [zoom, setZoom] = useState(setDefZoom(zoomOutMax, zoom));
    const [center, setCenter] = useState({
        lat: selectedLatLong?.lat,
        lng: selectedLatLong?.long
    });

    const defaultcenter = {
        lat: defaultCenter?.lat,
        lng: defaultCenter?.long
    };

    useEffect(() => {
        setZoom(setDefZoom(zoomOutMax, zoom));
    }, [userLatLong?.lat, userLatLong?.long]);
    
    useEffect(() => {
        setZoom(setDefZoom(zoomOutMax, zoom));
    }, [zoomOutMax, selectedLatLong?.lat, selectedLatLong?.long]);
    useEffect(() => {
        if (zoom > 5) {
            setCenter({ lat: selectedLatLong?.lat, lng: selectedLatLong?.long });
        }
    }, [zoom, selectedLatLong?.lat, selectedLatLong?.long]);

    return (
        <>
        <GoogleMapReact
            bootstrapURLKeys={{ key: googleApiKey }}
            // bootstrapURLKeys={{ key: 'AIzaSyBiyfHzyczl2hmeggn5qT_DzBMBBG7rSxs' }}
            defaultCenter={defaultcenter}
            center={center}
            zoom={zoom}
            // onGoogleApiLoaded={({ map }) => getMapBounds(map)}
            options={maps => ({
                styles: googleMapStyles,
                maxZoom: 15,
                minZoom: setMinZoom(),
                fullscreenControl: false,
                restriction: {
                    latLngBounds: MAP_LAT_LONG_BOUNDS
                },
                zoomControlOptions: {
                    position: maps.ControlPosition.RIGHT_TOP
                }
            })}
            yesIWantToUseGoogleMapApiInternals
            defaultZoom={7}>
            {storesList?.map((item, index) => {
                if (item?.latitude) {
                    //atleast one of the trainers is specialty
                    const isSpecialtyTrainerPresent = storesList?.some(
                        store => store?.assignedPc == item.assignedPc && isValidString(store?.specialtyTrainer)
                    );
                    return (
                        <Marker
                            key={index}
                            lat={item?.latitude}
                            itemData={item}
                            pc={item?.assignedPc}
                            onClickMarker={(item, companyId) => {
                                onClickMarker(item, companyId);
                            }}
                            selectedStoreValue={selectedStoreValue}
                            lng={item?.longitude}
                            setFocusedLocation={setFocusedLocation}
                            isSpecialty={isSpecialtyTrainerPresent}
                        />
                    );
                }
            })}
            {(isCurrentLocationAllowed || userLatLong) && (
                <div
                    lat={isCurrentLocationAllowed ? currentLocation?.lat : userLatLong?.lat}
                    lng={isCurrentLocationAllowed ? currentLocation?.long : userLatLong?.long}
                    data-testid="current-location-marker"
                    className="currentLocation">
                    <CurrentLocationMarker className="mapIcon" />
                </div>
                )}
                </GoogleMapReact>
                {mediaType !== MEDIA_TYPE.mobile && (
                    <LocationLegend
                        title={ENV_CONFIG.DST_LEGEND_TITLE}
                        legendItems={legendItems}
                        classNamePrefix="dst"
                    />)}
        </>
    );
};
TrainerMap.propTypes = {
    setLocationDeniedError: func,
    selectedLatLong: object,
    storesList: array,
    selectedStoreValue: number,
    onClickMarker: func,
    defaultCenter: object,
    setFocusedLocation: func,
    zoomOutMax: bool,
    legendItems: arrayOf(
        shape({
            name: string,
            icon: node,
            content: string,
            link: string
        })
    )
};

TrainerMap.defaultProps = {
    selectedLatLong: {},
    storesList: [],
    selectedStoreValue: null,
    onClickMarker: () => {},
    defaultCenter: {},
    setFocusedLocation: () => {},
    zoomOutMax: false,
    legendItems: [{}]
};
export default memo(TrainerMap);
